import { render, staticRenderFns } from "./VerDetalle.vue?vue&type=template&id=79a1e366&"
import script from "./VerDetalle.vue?vue&type=script&lang=ts&"
export * from "./VerDetalle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports